import { createQueryKeySet } from '@akin-home/utils/react-query';

export const system_property_query_keys = createQueryKeySet({
  key: 'system_properties',
});
